//#region modules
// import { BrowserModule } from '@angular/platform-browser';
import { AngularReactBrowserModule } from '@angular-react/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './ccp-routing.module';
import { PlannerModule } from './planner/planner.module';
import { RouteReuseStrategy } from '@angular/router';
import { CCPRouteReuseStrategy } from './core/classes/CCPRouteReuseStrategy';
import { OktaAuthModule } from '@okta/okta-angular';
//#endregion

//#region components
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { RedirectComponent } from './auth/redirect/redirect.component';
import { LoginComponent } from './login/login.component';
import { AppComponent } from './ccp.component';
import { RequestCacheService } from './services/request-cache.service';
import { CachingInterceptor } from './interceptors/caching-interceptor';
//#endregion

//#region external depedencies
import { AppCommonModule } from './common/common.module';
//#endregion

@NgModule({
    declarations: [
        AppComponent,
        RedirectComponent,
        LoginComponent
    ],
    imports: [
        AngularReactBrowserModule,
        HttpClientModule,
        PlannerModule,
        AppRoutingModule,
        AppCommonModule,
        OktaAuthModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        RequestCacheService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CachingInterceptor,
            multi: true
        },
        {
            provide: RouteReuseStrategy,
            useClass: CCPRouteReuseStrategy
        },
        CookieService
    ],
    bootstrap: [AppComponent],
    entryComponents: []
})
export class AppModule { }
